import { __decorate, __metadata, __param } from "tslib";
import _ from 'lodash';
import { inject, injectable } from 'inversify';
import { Symbols } from '../../symbols';
// 导出api比较耗时 目前给予5分钟超时
const EXPORT_TIMEOUT = 5 * 60 * 1000;
let ExportApi = class ExportApi {
    constructor(http, urls, boHelperService) {
        this.http = http;
        this.urls = urls;
        this.boHelperService = boHelperService;
    }
    // warning: 迁移到使用的Service中
    // get Today() {
    //     return dayjs().format('YYYYMMDD')
    // }
    // 名称规则
    //
    // ref: https://patsnap.atlassian.net/browse/TOC-37003
    // async exportCompanyService(company_name: string, params: IExportCompanyParams) {
    //     const data = await this.getExportCompany(params)
    //     const filename = this.i18n.t('export.export_company_template', {
    //         company_name,
    //         date: this.Today
    //     }) as string
    //     contentDownload(filename, data)
    // }
    // async exportCompaniesService(params: IExportCompaniesParams) {
    //     const data = await this.getExportCompanies(params)
    //     const filename = this.i18n.t('export.export_companies_template', {
    //         date: this.Today
    //     }) as string
    //     contentDownload(filename, data)
    // }
    // async exportUsersService(params: IExportUsersParams) {
    //     const data = await this.getExportUsers(params)
    //     const filename = this.i18n.t('export.export_users_template', {
    //         date: this.Today
    //     }) as string
    //     contentDownload(filename, data)
    // }
    // #region API
    getExportCompany(params) {
        const url = this.urls.getExportCompany;
        return this.http.get({
            url,
            params,
            responseType: 'blob',
            timeout: EXPORT_TIMEOUT,
        });
    }
    getExportCompanies(params) {
        const url = this.urls.getExportCompanies;
        params = this.boHelperService.maybeSerializeDate(params, 'start_date', 'end_date', 's_privilege_end_at_start', 's_privilege_end_at_end', 's_created_at_start', 's_created_at_end');
        const { sales_emails, s_charge_mode, ...otherParams } = params;
        return this.http.post({
            url,
            params: {
                ...otherParams,
                product_ids: _.join(otherParams.product_ids, ','),
            },
            data: _.pickBy({
                sales_emails,
                charge_modes: _.isEmpty(s_charge_mode) ? [] : _.split(s_charge_mode, ','),
            }, (value) => !_.isEmpty(value)),
            responseType: 'blob',
            timeout: EXPORT_TIMEOUT,
        });
    }
    getExportUsers(params) {
        const url = this.urls.getExportUsers;
        params = this.boHelperService.maybeSerializeDate(params, 'start_date', 'end_date', 's_end_at_start', 's_end_at_end', 's_last_login_start', 's_last_login_end', 's_created_at_start', 's_created_at_end');
        const { sales_emails, account_type_list, account_status_list, ...otherParams } = params;
        return this.http.post({
            url,
            params: {
                ...otherParams,
                product_ids: _.join(otherParams.product_ids, ','),
            },
            data: _.pickBy({
                sales_emails: _.join(sales_emails, ','),
                account_type_list,
                account_status_list,
            }, (value) => !_.isEmpty(value)),
            responseType: 'blob',
            timeout: EXPORT_TIMEOUT,
        });
    }
};
ExportApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.ExportApiUrls)),
    __param(2, inject(Symbols.BoHelperService)),
    __metadata("design:paramtypes", [Object, Object, Object])
], ExportApi);
export { ExportApi };
